import axios from 'axios';

import { deleteCookie } from './cookies';
import { saveLoginReferrer } from './loginReferrer';

export function forceLogout() {
  deleteCookie('access_token');
  deleteCookie('refresh_token');
  delete axios.defaults.headers.common['Authorization'];

  // Clear persisted Redux state
  localStorage.removeItem('persist:root');

  // Save current URL before redirect
  saveLoginReferrer();

  if (window.location.pathname !== '/auth/login') {
    // Redirect to login page
    window.location.href = '/auth/login';
  }
}
